import { gql } from "@apollo/client";

const UPDATE_CAPA = gql`
    mutation updateGestionCapa($input: EditGestionCapaInput! ){
        updateGestionCapa(input: $input) {
            idGestionCapa
        }
    }
`;

export default UPDATE_CAPA;

const stageAdapters = {
  // Etapa 1: Creador Capa
  stage1: (data) => ({
    pantallaIngreso: {
      idDelegacion: data.idDelegacion,
      idFuente: data.idFuente,
      idGestionReclamo: data.idGestionReclamo,
      idArea: data.idArea,
      idResponsableAccion: data.idResponsableAccion,
      descripcion: data.descripcion,
      causa: data.causa,
      accion: data.accion,
      fechaAccion: data.fechaAccion,
      observacion: data.observacion
    }
  }),

  // Etapa 2: Primera Revisión
  stage2: (data) => ({
    pantallaIngreso: null
  }),

  // Etapa 3: Segunda Revisión
  stage3: (data) => ({
    pantallaRevision: {
      fechaCierreAccion: data.fechaCierreAccion,
      listaProrroga: data.prorrogaCapa?.map((prorroga) => adaptProrroga(prorroga))
    }
  }),

  // Etapa 4: Revision Prorroga
  stage4: (data) => ({
    pantallaRevision: {
      fechaCierreAccion: data.fechaCierreAccion
    }
  }),

  // Etapa 5: Aprobación Final
  stage5: (data) => (
  {
    pantallaAprobacion: {
      fechaCierre: data.fechaCierre,
      observacionFinal: data.observacionFinal,
      capaVencida: data.capaVencida
    }
  })
};

export const adaptProrroga = (prorroga) => {
  return {
    fechaAlta: prorroga?.fechaAlta,
    fechaProrroga: prorroga?.fechaProrroga,
    idGestionCapa: prorroga?.idGestionCapa,
    idProrrogaCapa: prorroga?.idProrrogaCapa,
    idUsuarioAlta: prorroga?.idUsuarioAlta,
    justificacion: prorroga?.justificacion,
    aprobada: prorroga?.aprobada
  };
};

export const adaptEditGestionCapaInput = (stageData, idGestionCapa, pantalla, idEstadoCapa, idEtapaCapa) => {
  const stageName = `stage${idEtapaCapa}`;
  const adapter = stageAdapters[stageName];

  if (!adapter) {
    throw new Error(`No existe adaptador para la etapa ${stageName}`);
  }

  // Construimos el input base con los campos requeridos
  const baseInput = {
    idGestionCapa,
    pantalla,
    // Inicializamos todos los campos nullables como null
    pantallaIngreso: null,
    pantallaRevision: null,
    pantallaAprobacion: null
  };

  // Aplicamos el adaptador específico de la etapa y combinamos con el input base
  const adaptedStageData = adapter(stageData);
  return {
    ...baseInput,
    ...adaptedStageData
  };
};